import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { media } from '../ui/common';

export const Section = styled.section`
  padding-top: 120px;
  padding-bottom: 28px;
  ${media.phone`
    padding-bottom: 60px;
  `}
`;
export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
`;
export const Wrap = styled.div``;
export const ImageWrapper = styled.div`
  padding-top: 56px;
  ${media.phone`
    padding-top: 40px;
  `}
  ${media.medium`
    padding-top: 0;
  `}
`;
export const Block = styled.div`
  margin: 0;
  width: 50%;
  padding: 0 8px;
  box-sizing: border-box;
`;

export const Image = styled(GatsbyImage)`
  width: 100%;
  margin: 13px 0;
  ${media.laptop`
    margin: 16px 0;
  `}
`;
export const Picture = styled(GatsbyImage)`
  height: 540px;
`;
